import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import { useTranslations } from "@/shared/lang/useTranslations";

import type { ApiKeyStatus } from "../utils/apiKeyStatus";

const STATUS_VARIANT = {
  active: "success",
  expired: "warning",
  inactive: "neutral",
} as const;

const STATUS_LABEL = {
  active: "access_apikeys_status_active",
  expired: "access_apikeys_status_expired",
  inactive: "access_apikeys_status_inactive",
} as const;

export interface ApiKeyStatusPillProps {
  status: ApiKeyStatus;
}

/**
 * The key's state at the gate. Shared by the table and the cards so the two can never label the same key
 * differently — the maps used to be copied into both.
 *
 * `expired` is `warning` and not `danger`: an expired key is not a failure, it is a deadline that passed.
 * `inactive` is neutral for the same reason the users table dims a suspended row instead of tinting it —
 * somebody turned it off on purpose.
 */
export function ApiKeyStatusPill({ status }: ApiKeyStatusPillProps) {
  const { t } = useTranslations("settings");

  return (
    <ColocaStatusPill variant={STATUS_VARIANT[status]} withDot>
      {t(STATUS_LABEL[status])}
    </ColocaStatusPill>
  );
}
